import { useMemo } from "react";

import { annotationPlugin } from "@features/custom-annotations";
import { type CurrencyCode } from "@north-beam/nb-common";

import { alignAxesScalePlugin } from "./align-axes-scale-plugin";
import { chartDataManagerPlugin } from "./chart-data-manager-plugin";
import { highlightDatasetOnHoverPlugin } from "./highlight-dataset-on-hover-plugin";
import { splitChartDataViewPlugin } from "./split-chart-data-view-plugin";
import { xAxisSummaryTooltipPlugin } from "./x-axis-summary-tooltip-plugin";
import { yScaleTitlesPlugin } from "./y-scale-titles-plugin";

const plugins = (code: CurrencyCode) => [
  yScaleTitlesPlugin,
  chartDataManagerPlugin,
  splitChartDataViewPlugin,
  xAxisSummaryTooltipPlugin(code),
  highlightDatasetOnHoverPlugin,
  annotationPlugin,
  alignAxesScalePlugin,
];

export const usePlugins = (code: CurrencyCode) =>
  useMemo(() => plugins(code), []);
